export default "__VITE_ASSET__CQ1zmK0___"